/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/assets/scss/styles.scss";

// gatsby-browser.js
import React from "react";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import "./src/assets/scss/styles.scss";

export const wrapRootElement = ({ element }) => (
  <PayPalScriptProvider options={{ clientId: process.env.GATSBY_PAYPAL_CLIENT_ID || "test", currency: "NZD", locale: "en_NZ" }}>
    {element}
  </PayPalScriptProvider>
);